import React from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'

function ActivityBoxInterests({ activityCount, activityText, handleInvites }) {
  const { t } = useTranslation()
  const activityCountZero = activityCount === 0 || activityCount === '0' || activityCount === '0%'
  return (
    <div className={styles.activityInterests}>
      <div className={styles.contentBox}>
        <div className={styles.number}>{activityCount || '0'}</div>
        <div className={styles.mainContent}>
          <div className={styles.text}>{activityText}</div>
          {!activityCountZero && (
            <Button
              text={t('dashboard.interests.inviteAll')}
              type='button'
              style='transparent'
              disabled={activityCountZero}
              customStyle={activityCountZero ? styles.hidden : ''}
              handleClick={handleInvites}
            />
          )}
        </div>
      </div>
    </div>
  )
}

ActivityBoxInterests.propTypes = {
  activityCount: PropTypes.string,
  activityText: PropTypes.string,
  activityTitle: PropTypes.string,
  boxColor: PropTypes.string,
  isTextLight: PropTypes.bool,
  hasIcon: PropTypes.bool,
  isIconFlipped: PropTypes.bool,
  iconName: PropTypes.string
}

ActivityBoxInterests.defaultProps = {
  activityCount: '',
  activityText: '',
  activityTitle: '',
  boxColor: '',
  isTextLight: false,
  hasIcon: false,
  isIconFlipped: false,
  iconName: ''
}

export default ActivityBoxInterests
